import React, {useReducer, useEffect} from 'react';

import {getReactionConfig, ActionTypes, reducer} from '~/src/utilities/helpers/reaction';

const ReactionContext = React.createContext([]);

const ReactionProvider = ({enabled, children}) => {
    const [state, dispatch] = useReducer(reducer, {
        config: []
    });

    process.browser &&
        useEffect(() => {
            if (enabled) {
                getReactionConfig().then((data) => {
                    dispatch({type: ActionTypes.UPDATE_CONFIG, data});
                });
            } else {
                dispatch({type: ActionTypes.UPDATE_CONFIG});
            }
        }, []);

    return <ReactionContext.Provider value={state.config}>{children}</ReactionContext.Provider>;
};

export {ReactionContext};

export default ReactionProvider;
